// extracted by mini-css-extract-plugin
module.exports = {"container":"da-z","copy":"ea-z","field":"fa-z","error":"ga-z","disabled":"ha-z","termsContainer":"ia-z","termsHeading":"ja-z","termsCopy":"ka-z","submit":"la-z","srOnly":"ma-z"};